export interface TestConfig {
  questions: Question[];
  finalScreen: FinalScreen;
  onSuccess: () => void | Promise<void>;
  onAllCorrect: () => void | Promise<void>;
  onExit: () => void;
}

export interface Question {
  question: string;
  answers: Answer[];
  correctId: number[];
}

export interface Answer {
  id: number;
  text: string;
}

export interface AnswerHistory {
  selected: number[];
  isCorrect: boolean;
  counted: boolean;
}

export interface FinalScreen {
  title: string;
  description: string;
  image: string;
}

export enum TestQueryParam {
  TYPE = 'type',
}

export enum TestType {
  TRAINEE_TRAINING = 'trainee-training',
}
